var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRaAccessPrivate(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "people-fill",
    clipPath: "url(#clip0_2253_101412)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Exclude",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.5 19.5C0.5 21 2 21 2 21H12.5V22.25C12.5 22.7141 12.6896 23.1592 13.0272 23.4874C13.3648 23.8156 13.8226 24 14.3 24H19.7C20.1774 24 20.6352 23.8156 20.9728 23.4874C21.3104 23.1592 21.5 22.7141 21.5 22.25V17.875C21.5 17.4109 21.3104 16.9658 20.9728 16.6376C20.6352 16.3094 20.1774 16.125 19.7 16.125V12.625C19.7 11.9288 19.4155 11.2611 18.9092 10.7688C18.4028 10.2766 17.7161 10 17 10C16.2839 10 15.5972 10.2766 15.0908 10.7688C14.5845 11.2611 14.3 11.9288 14.3 12.625V16.125C14.2528 16.125 14.2057 16.1268 14.159 16.1304C13.0549 14.7372 11.146 13.5 8 13.5C2 13.5 0.5 18 0.5 19.5ZM14.7417 17C14.5789 16.7098 14.386 16.4168 14.159 16.1304C13.7332 16.1629 13.3314 16.3418 13.0272 16.6376C12.6896 16.9658 12.5 17.4109 12.5 17.875V21H13.4V22.25C13.4 22.4821 13.4948 22.7046 13.6636 22.8687C13.8324 23.0328 14.0613 23.125 14.3 23.125H19.7C19.9387 23.125 20.1676 23.0328 20.3364 22.8687C20.5052 22.7046 20.6 22.4821 20.6 22.25V17.875C20.6 17.6429 20.5052 17.4204 20.3364 17.2563C20.1676 17.0922 19.9387 17 19.7 17H14.7417ZM14.7417 17C15.297 17.9904 15.5 18.9482 15.5 19.5C15.5 21 14 21 14 21H13.4V17.875C13.4 17.6429 13.4948 17.4204 13.6636 17.2563C13.8324 17.0922 14.0613 17 14.3 17H14.7417ZM11.182 10.682C10.3381 11.5259 9.19347 12 8 12C6.80653 12 5.66193 11.5259 4.81802 10.682C3.97411 9.83807 3.5 8.69347 3.5 7.5C3.5 6.30653 3.97411 5.16193 4.81802 4.31802C5.66193 3.47411 6.80653 3 8 3C9.19347 3 10.3381 3.47411 11.182 4.31802C12.0259 5.16193 12.5 6.30653 12.5 7.5C12.5 8.69347 12.0259 9.83807 11.182 10.682ZM18.2728 11.3876C17.9352 11.0594 17.4774 10.875 17 10.875C16.5226 10.875 16.0648 11.0594 15.7272 11.3876C15.3896 11.7158 15.2 12.1609 15.2 12.625V16.125H18.8V12.625C18.8 12.1609 18.6104 11.7158 18.2728 11.3876Z",
    fill: "#1C2026"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2253_101412"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRaAccessPrivate);
export default __webpack_public_path__ + "static/media/ra-access-private.838445fbd7db5d63e5686e399ac5ce7b.svg";
export { ForwardRef as ReactComponent };